module.exports = __webpack_public_path__ + "img/bg-head-small.8ae817e0.png";